var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H5V4.5H10V4Z",
    fill: "#055CC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4V6.5H1V4H4.5Z",
    fill: "#055CC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5H5V6H10V5.5Z",
    fill: "#055CC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H10V7.5H1V7Z",
    fill: "#055CC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5H1V9H10V8.5Z",
    fill: "#055CC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9412 11H1.05882C0.475059 11 0 10.5341 0 9.96154V3C0.0136367 2.63461 0.221471 2.31676 0.524317 2.14231C0.564551 2.05814 0.650485 2 0.75 2C0.78524 2 0.818777 2.00729 0.849185 2.02045C0.916969 2.00704 0.987075 2 1.05882 2H10.9412C11.5249 2 12 2.46592 12 3.03846V9.96154C12 10.5341 11.5249 11 10.9412 11ZM0.708223 3C0.727819 2.82727 0.877777 2.69231 1.059 2.69231H10.9413C11.1358 2.69231 11.2943 2.84773 11.2943 3.03846V9.96154C11.2943 10.1523 11.1358 10.3077 10.9413 10.3077H1.059C0.864525 10.3077 0.706055 10.1523 0.706055 9.96154V3.5H11V3H0.708223Z",
    fill: "#055CC0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/Site.ddcbcaa330916ceac164c2e78b53c027.svg";
export { ForwardRef as ReactComponent };